const STEPS = [
  { n: '1', title: 'Discover', text: 'We start with the decisions you need to make, then work back to the KPIs, stakeholders, and source systems behind them.' },
  { n: '2', title: 'Build', text: 'We design the data flows and the dashboards together, checking in with you at every milestone so nothing comes as a surprise.', color: '#003A70' },
  { n: '3', title: 'Enable', text: 'We launch, train your team, and document everything, so you can run it and extend it without us.', color: '#8b5cf6' },
];

export const ProcessTimeline = () => (
  <section className="section" id="process">
    <div className="container">
      <div className="heading">
        <h2>A structured path from raw data to lasting capability.</h2>
        <p>Every phase keeps your stakeholders aligned and your decisions moving.</p>
      </div>
      <div className="process-grid">
        {STEPS.map((s) => (
          <article className="step" key={s.n} data-testid={`process-step-${s.n}`}>
            <div className="number" style={s.color ? { background: s.color } : undefined}>{s.n}</div>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
